import axios from 'axios';
import cookies from 'browser-cookies';
import config from './config.api';
import { getApiEnvironment, getService } from '../utils';
export const baseFlowGptUrl = getService('flowGPT', config, getApiEnvironment());
export const flowGptApi = axios.create({
    baseURL: baseFlowGptUrl,
    timeout: 60000,
});
flowGptApi.interceptors.request.use(conf => {
    conf.headers.Authorization =
        'Bearer ' + cookies.get('auth0.user.token');
    return conf;
}, error => {
    Promise.reject(error);
});
export default flowGptApi;
